<ion-button (click)="setOpen(true)">Add Image</ion-button>
<ion-action-sheet
  [isOpen]="isActionSheetOpen"
  [buttons]="actionSheetButtons"
  (didDismiss)="setOpen(false)"
></ion-action-sheet>
